var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 11338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.86857 6.408C2.54776 5.08259 3.58969 3.96841 4.8779 3.18998C6.16612 2.41154 7.64985 1.99953 9.16327 2C11.3633 2 13.2114 2.792 14.6245 4.084L12.2841 6.3784C11.4376 5.5856 10.3616 5.1816 9.16327 5.1816C7.03674 5.1816 5.23674 6.5896 4.59592 8.48C4.43265 8.96 4.33959 9.472 4.33959 10C4.33959 10.528 4.43265 11.04 4.59592 11.52C5.23755 13.4112 7.03674 14.8184 9.16327 14.8184C10.2612 14.8184 11.1959 14.5344 11.9273 14.0544C12.3514 13.7808 12.7144 13.4258 12.9945 13.0108C13.2745 12.5958 13.4658 12.1295 13.5567 11.64H9.16327V8.5456H16.8514C16.9478 9.0688 17 9.6144 17 10.1816C17 12.6184 16.1102 14.6696 14.5657 16.0616C13.2155 17.284 11.3673 18 9.16327 18C8.09113 18.0004 7.02942 17.7938 6.03881 17.3919C5.0482 16.99 4.14812 16.4007 3.39001 15.6578C2.63189 14.9148 2.03061 14.0328 1.62052 13.062C1.21043 12.0912 0.999572 11.0507 1 10C1 8.7088 1.3151 7.488 1.86857 6.408Z",
    fill: "#eb2426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleActive);
export default __webpack_public_path__ + "static/media/google_active.c58d4f47430c35e343adf25f28a94904.svg";
export { ForwardRef as ReactComponent };